import { gsap, ScrollTrigger } from "./globals.js";
import { animateChars } from './animate-chars.js';
import { isLargeNonTouchDevice } from './globals.js';

document.addEventListener("DOMContentLoaded", () => {
	// CENTER TEXT
	const centerText = document.querySelector(".center-text");
	if (centerText) {
		document.querySelectorAll(".center-text").forEach((section) => {
		  const imageEls = section.querySelectorAll(".center-text__img");
		  const textWrap = section.querySelector(".center-text__wrap");

		  const imageAnimations = [
		    { x: -100, y: -100 }, // top-left
		    { x: 100, y: -100 },  // top-right
		    { x: -100, y: 100 },  // bottom-left
		    { x: 100, y: 100 }    // bottom-right
		  ];

		  const tl = gsap.timeline({
		    scrollTrigger: {
		      trigger: section,
		      start: "top 80%",
		      end: "bottom 50%",
		      scrub: 4,
		    }
		  });

		  imageEls.forEach((img, index) => {
		    const pos = imageAnimations[index % imageAnimations.length];

		    tl.fromTo(img, {
		      opacity: 0,
		      x: pos.x,
		      y: pos.y
		    }, {
		      opacity: 1,
		      x: 0,
		      y: 0,
		      duration: 3,
		      ease: "power2.out"
		    }, index * 0.1); // Slight stagger
		  });

		  tl.add(animateChars('.center-text__wrap'), "-=3"); // Overlap with images
		});

		// IMAGE MOVEMENT
		if (isLargeNonTouchDevice()) {
			const bounds = centerText.getBoundingClientRect();
			const imgInners = document.querySelectorAll(".center-text__img-wrap");
			const imgTransforms = Array.from(imgInners).map(inner => ({
				x: gsap.quickTo(inner, "x", { duration: 3, ease: "power3.out" }),
				y: gsap.quickTo(inner, "y", { duration: 3, ease: "power3.out" }),
				rotX: gsap.quickTo(inner, "rotationX", { duration: 3, ease: "power2.out" }),
				rotY: gsap.quickTo(inner, "rotationY", { duration: 3, ease: "power2.out" })
			}));

			centerText.addEventListener("mousemove", (e) => {
				const bounds = centerText.getBoundingClientRect();
				const centerX = bounds.left + bounds.width / 2;
				const centerY = bounds.top + bounds.height / 2;
				const offsetX = (e.clientX - centerX) / bounds.width;
				const offsetY = (e.clientY - centerY) / bounds.height;

				imgTransforms.forEach(({ x, y }) => {
					const strength = 100;
					x(offsetX * strength * -1);
					y(offsetY * strength * -1);
				});
			});
		}
	}
});
